import { Tabs } from "devextreme-react";
import { useState } from "react";
import SummaryGrid from "./SummaryGrid";

const Summary = ({ handleClickMenu, setYearMonth, yearMonth }) => {
  const [summaryType, setSummaryType] = useState("studyStatus");
  const [tabDataSource] = useState([
    { text: "Study Status", type: "studyStatus" },
    { text: "Issues", type: "issue" },
  ]);

  const handleClickTab = (e) => {
    setSummaryType(e.itemData.type);
  };

  const renderTabItem = (e) => {
    return <div style={{ fontSize: "16px", fontWeight: "bold", color: "black", textTransform: "none" }}>{e.text}</div>;
  };

  return (
    <>
      <Tabs
        dataSource={tabDataSource}
        defaultSelectedIndex={0}
        height={40}
        itemRender={renderTabItem}
        onItemClick={handleClickTab}
        width={450}
      />
      <div style={{ height: "16px" }} />
      <SummaryGrid
        handleClickMenu={handleClickMenu}
        setYearMonth={setYearMonth}
        summaryType={summaryType}
        yearMonth={yearMonth}
      />
    </>
  );
};

export default Summary;
